module.exports = __webpack_public_path__ + "img/tag_银分赛事@2x.86d02f75.png";